import { c as _c } from "react/compiler-runtime";
import HeroWithImage from "@/components/homepage/HeroWithImage";
import SlideshowSection from "@/components/homepage/SlideshowSection";
import BrowseRange from "@/components/homepage/BrowseRange";
import SideImage from "@/components/homepage/SideImage";
import ServicesPromo from "@/components/homepage/ServicesPromo";
import BrowseCollections from "@/components/homepage/BrowseCollections";
import FeaturedCollections from "@/components/homepage/FeaturedCollections";
import HomeFaqs from "@/components/homepage/HomeFaqs";
import ReviewsSlider from "@/components/homepage/ReviewsSlider";
import TextSection from "@/components/homepage/TextSection";
import CustomText from "@/components/homepage/CustomText";
import FeaturedOptions from "@/components/homepage/FeaturedOptions";
import PeopleSearch from "@/components/homepage/PeopleSearch";
import VideoWithText from "@/components/homepage/VideoWithText";
import TopSellerSlider from "@/components/homepage/TopSellerSlider";
import FeaturedLinks from "@/components/homepage/FeaturedLinks";
export default function HomeSections(t0) {
  const $ = _c(5);
  const {
    sections,
    reviews
  } = t0;
  let t1;
  if ($[0] !== reviews || $[1] !== sections) {
    t1 = Array.isArray(sections) && sections.length > 0 && sections.map((section, index) => {
      const sjson = section?.section_json;
      const section_slug = sjson?.stype_slug;
      const section_data = sjson?.stype_json;
      if (!section_slug) {
        return null;
      }
      const isAboveFold = index <= 1;
      return <div key={index} className={`homepage relative bg-slate-50 p${section?.sort_order || ""} ${section_slug}`}>{section_slug === "hero_banner" && <HeroWithImage fbanner={section_data} />}{section_slug === "slide_show" && <SlideshowSection fshows={section_data} isAboveFold={isAboveFold} />}{section_slug === "popular_range" && <BrowseRange sbcats={section_data} />}{section_slug === "image_with_text" && <SideImage simage={section_data} />}{section_slug === "services_promo" && <ServicesPromo servs={section_data} />}{section.section_json.stype_slug === "featured_products" && <TopSellerSlider tps={section_data} />}{section_slug === "browse_collection" && <BrowseCollections bcols={section_data} />}{section_slug === "featured_collections" && <FeaturedCollections fcols={section_data} />}{section_slug === "featured_links" && <FeaturedLinks flinks={section_data} />}{section_slug === "faqs" && <HomeFaqs afaqs={section_data} />}{section_slug === "review_slider" && <ReviewsSlider areviews={section_data} reviews={reviews} />}{section_slug === "text_section" && <TextSection atext={section_data} />}{section_slug === "custom_text" && <CustomText ctext={section_data} />}{section_slug === "featured_options" && <FeaturedOptions featured_options={section_data} />}{section_slug === "people_search" && <PeopleSearch psearch={section_data} />}{section_slug === "video_with_text" && <VideoWithText svideo={section_data} />}</div>;
    });
    $[0] = reviews;
    $[1] = sections;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t1) {
    t2 = <>{t1}</>;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
}